import { notification } from 'antd';
import { IRegras, IRegrasFormValues } from '../interface';
import { useCallback, useRef, useState } from 'react';

import axios from 'axios';
import RegrasReceitasService from '../../../services/http/services/ConfiguracoesReceitas/RegrasReceitasService';

const options_categoria = [
    {
        label: 'Receita Corrente',
        value: 'receita_corrente',
    },
    {
        label: 'Deduções',
        value: 'deducoes',
    },
];

export const useRegras = () => {
    const [regras, setRegras] = useState<IRegras[]>([]);
    const [loading, setLoading] = useState(false);
    const [loadingRegraModal, setLoadingRegraModal] = useState(false);

    const signalRef = useRef(axios.CancelToken.source());

    const getRegras = useCallback(async () => {
        setLoading(true);
        try {
            const data = await RegrasReceitasService.getRegras(signalRef.current.token);
            setRegras(data);
        } catch (error) {
            if (!axios.isCancel(error)) {
                notification.error({
                    message: 'Erro',
                    description: 'Erro ao carregar regras!'
                });
            }
        } finally {
            setLoading(false);
        }
    }, []);

    const postRegras = useCallback(async (values: IRegrasFormValues) => {
        setLoadingRegraModal(true);
        try {
            const novoGrupo = await RegrasReceitasService.postRegras(values, signalRef.current.token);

            notification.success({
                message: 'Sucesso',
                description: 'Regra atualizada com sucesso!',
            });

            await getRegras();
            return novoGrupo;
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível atualizar!',
            });
            return null;
        } finally {
            setLoadingRegraModal(false);
        }

    }, [getRegras]);

    const updateRegras = useCallback(async (values: IRegrasFormValues) => {
        setLoadingRegraModal(true);
        try {
            const novoGrupo = await RegrasReceitasService.putRegras(values, signalRef.current.token);

            notification.success({
                message: 'Sucesso',
                description: 'Regra atualizada com sucesso!',
            });

            await getRegras();
            return novoGrupo;
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível atualizar!',
            });

            return null;
        } finally {
            setLoadingRegraModal(false);
        }
    }, [getRegras]);

    const deleteRegra = useCallback(async (ano: number) => {
        try {
            await RegrasReceitasService.deleteRegras(ano, signalRef.current.token);

            notification.success({
                message: 'Sucesso',
                description: 'Regra apagada!'
            });

            await getRegras();
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Não foi possível apagar regra!'
            });
        }
    }, [getRegras]);

    const handleUpload = useCallback(async (file: File, ano: number) => {
        try {
            setLoadingRegraModal(true);

            const formData = new FormData();
            formData.append('file', file);

            const response = await RegrasReceitasService.uploadFile(
                formData,
                ano,
                signalRef.current.token
            );

            notification.success({
                message: 'Sucesso',
                description: 'Arquivo enviado com sucesso!',
            });

            return response;
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Falha ao enviar arquivo',
            });

            return null;
        } finally {
            setLoadingRegraModal(false);
        }
    }, []);

    return {
        regras,
        loading,
        loadingRegraModal,
        options_categoria,
        getRegras,
        postRegras,
        deleteRegra,
        updateRegras,
        handleUpload,
    };
};
